import React from 'react';
import { ConstantPermissions } from 'contexts/useConstant';
import EntryInventory from 'components/Tvendo/Inventory/Operations/Kardex/KardexSharedFile';

export default function () {
  return (
    <EntryInventory
      title="entradas de inventario"
      excelName="entradas_inventario"
      type="ETI" //ET = entradas inventory
      entity="logi/entry"
      permissions={{
        store: ConstantPermissions.LOGI_INVENTORIES_STORE,
        show: ConstantPermissions.LOGI_INVENTORIES_SHOW,
        delete: ConstantPermissions.LOGI_INVENTORIES_DELETED
      }}
    />
  );
}
